import React from 'react';
import { useSelector } from 'react-redux';
import { Paper } from '@mui/material';
import chartSx from './Chart.styles';
import { useTheme } from '@mui/material/styles';



const CodeDefinitions = ({ title, symbolType }) => {
	const codes = useSelector(state => [
			  ...(state.chart.chart_symbols_buccal || []),
			  ...(state.chart.chart_symbols_occlusal || []),
		  ]),
		  theme = useTheme(),
		  sx    = chartSx(theme);


	let filtered    = codes
			.filter(code => code.symbol_type === symbolType)
			.map(code => `${code.render_value} - ${code.symbol_name}`),
		definitions = [ ...new Set(filtered) ];


	return (
		<Paper elevation={2} sx={{ mt: 2, p: 1, ...(sx.bottomBoxes || {}) }}>
			<div>
				<strong>{title}</strong>
				<ul>
					{definitions.map((def, index) => (
						<li key={index}>
							<span>{def}</span>
						</li>
					))}
				</ul>
			</div>

		</Paper>
	);
};


export default CodeDefinitions;
